"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBasketsAwaitingApproval = void 0;
/**
 * Allows you to get a list of baskets awaiting approval for a specific company
 */
var getBasketsAwaitingApproval = function (instance) { return function (code, config) {
    return instance.get("/catalogues/baskets/awaiting-approval/".concat(code), config);
}; };
exports.getBasketsAwaitingApproval = getBasketsAwaitingApproval;
